import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { costBreakdownWidgetCostsSelector } from "./costBreakdownWidgetCostsSelector";

export const costBreakdownWidgetPrevTotalCostSelector = createDraftSafeSelector(
  [costBreakdownWidgetCostsSelector],
  (costs) => {
    return costs.previousPeriodTotal;
  },
);
